<template>
  <div class="row">

    <div class="col-12">
      <div class="row">
        <div class="col-12 border-right" style="height: 800px; overflow-y: scroll;">
          <b-badge variant="light">{{ $t('ecdis.ecdis') }}</b-badge>
          <br><br>
          <Ecdis v-model="items" :fields="fields"></Ecdis>
        </div>

<!--        <div class="col-4 border-right" style="height: 800px; overflow-y: scroll;">-->
<!--          <b-badge variant="light">DETAILS</b-badge>-->
<!--          <br/><br/>-->
<!--          <Details v-model="items" :fields="fields"></Details>-->
<!--        </div>-->

      </div>
    </div>

  </div>
</template>

<script>
import Ecdis from "@/views/ecdis/Ecdis.vue";
import {eventBus} from "@/main";

export default {
  components: {Ecdis},
  data() {
    return {
      fields: [
        {key: 'email', label: this.$t('ecdis.email'), type: 'email', sortable: false, tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'ship_name', label: this.$t('ships.shipName'), type: 'text', sortable: false, tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'ship_imo', label: this.$t('ships.imo'), type: 'text', tdClass: 'small-black', thClass: 'small-gray'},
        // {key: 'imo', label: 'IMO', type: 'number', tdClass: 'small-black', thClass: 'small-gray'},
        // {key: 'mmsi', label: 'MMSI', type: 'number', tdClass: 'small-black', thClass: 'small-gray'},
        {
          key: 'ship_category', label: this.$t('ecdis.category'), type: 'select',
          options: [
            'Barge',
            'WMS',
            'Vehicle Carrier',
            'Combination',
            'Container',
            'Dredger',
            'Icebreaker',
            'Not a Vessel',
            'Naval Vessel',
            'Passenger Vessel',
            'Pilot',
            'Research Vessel',
            'Reefer',
            'Ro-Ro',
            'Salvage Vessel',
            'Survey Vessel',
            'Tug',
            'Vessel Traffic System',
            'Dry Cargo/Passenger',
            'Fishing',
            'Bulk Carriers',
            'Offshore',
            'Miscellaneous',
            'Tankers',
            'Inland Waterways',
            'Non-Merchant Ships',
            'Non Propelled',
            'Non Ship Structures'
          ],
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'ecdis_brand', label: this.$t('ships.brand'), type: 'select',
          options: [
            'dKart',
            'FURUNO',
            'GEM Elettronica',
            'GMSTECH',
            'Highlander',
            'Kelvin Hughes',
            'Kongsberg Maritime',
            'Maris',
            'mKart MEGA ECDIS',
            'NAUDEQ',
            'Navis USA LLC',
            'NaviSailor',
            'PC Maritime',
            'Raytheon Anschütz',
            'Seatronx',
            'Sodena',
            'Sperry Marine',
            'TOKIO KEIKI',
            'Transas',
            'JRC',
            'Unknown'],
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'ecdis_os', label: this.$t('ships.os'), type: 'select',
          options: [
            'Windows',
            'Linux',
            'Android'],
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'ecdis_type', label: this.$t('general.type'), type: 'select',
          options: [
            this.$t('general.primary'),
            this.$t('general.backup'),],
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {key: 'permit', label: this.$t('ecdis.permit'), type: 'text', tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'edit', label: '', type: 'edit'}
      ],
      items: [
      ]
    }
  },
  methods: {},
}
</script>
